var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-primary', {
          attrs: {
            "itemTitle": "제품소개",
            "tabActive": "케이장",
            "bg": "/images/sub/about/visual.jpg"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v(_vm._s(_vm.$t("제품소개")))];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first page-section--last"
  }, [_c('sub-product-info', {
    attrs: {
      "num": "02",
      "name": "케이장",
      "tag": "kZang.tag"
    },
    scopedSlots: _vm._u([{
      key: "txt",
      fn: function () {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.$t('kZang.txt2'))
          }
        })];
      },
      proxy: true
    }])
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }